import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { DotGrid } from './graphics/DotGrid';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden" data-id="element-141">
      <DotGrid data-id="element-142" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full" data-id="element-143">
        <div className="max-w-4xl" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-neutral-100 border border-neutral-200 text-xs font-medium text-neutral-600 mb-8" data-id="element-145">
            <span className="w-2 h-2 rounded-full bg-accent animate-pulse-slow" data-id="element-146" />
            The 5th Great Shift in Business Computing
          </motion.div>

          <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif leading-[1.05] tracking-tight mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-147">
            Operate{' '}
            <span className="text-neutral-400 italic" data-id="element-148">
              30% more efficiently
            </span>{' '}
            with <span className="text-accent" data-id="element-149">20% less staff.</span>
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-neutral-600 max-w-2xl mb-10 leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-150">
            Our proven framework utilizes Anthropic Claude and transforms your
            organization through AI training, deep AI workflow integration, and
            outcome tracking to unlock unprecedented organizational leverage.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-151">
            <a href="#contact" className="inline-flex items-center justify-center px-6 py-3.5 text-base font-medium text-white bg-foreground hover:bg-accent transition-colors rounded-full group" data-id="element-152">
              Book a discovery call
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-153" />
            </a>
            <a href="#approach" className="inline-flex items-center justify-center px-6 py-3.5 text-base font-medium text-foreground hover:text-accent transition-colors" data-id="element-154">
              See our approach
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}